// extracted by mini-css-extract-plugin
export default {"loginPage":"Login_loginPage__SJU6q","loginSection":"Login_loginSection__NE2rT","logo":"Login_logo__I0JH8","sideImageSection":"Login_sideImageSection__zYxkB"};